export default {
  SET_CART(state, data) {
    state.items = data.data
    state.total = data.data?.length
  },
  SET_ITEMS_CART(state, data) {
    state.items = data
  },
}